import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { UntypedFormGroup, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { CommonCriteriaService } from 'src/app/services/common/common-criteria.service';
import { CommonSummaryService } from 'src/app/services/common/common-summary.service';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { GridApi } from 'ag-grid-community';
import { EditAndDeleteOperationsRenderer } from 'src/app/common/client-grid/edit-and-delete-operations.component';
import { IstSummaryService } from '../../services/ist/ist-summary.service';
import { AttachmentClassificationComponent } from '../attachment-classification/attachment-classification.component';
import { IstDataShareService } from '../../services/ist/ist-datashare.service';
import { MessageBoxComponent } from '../message-box/message-box.component';
import { httpOptions, serviceConstants } from '../../constants/service.constants';
import { DeleteBoxComponent } from '../delete-box/delete-box.component';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'upload-grid-details',
  templateUrl: './upload-grid-details.component.html',
  styleUrls: ['./upload-grid-details.component.scss']
})
export class UploadGridDetails implements OnInit {
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  amdTypeOptions = [];
  amemdmentsForm: UntypedFormGroup;
  columnDefs;
  gridApi: GridApi;
  rowData;
  context;
  gridOptions;
  frameworkComponents;
  loadGrid = false;
  content: any
  heading: string;
  action: Subject<any> = new Subject();
  @Input() TransactionID: any;
  @Input() ViewPermission: string;
  @Input() ModuleName: string;
  @Input() ScreenName: string;
  ApplicationID: any;
  IsRequestScreen = false;
  selectedRow: any;
  constructor(
    private criteriaService: CommonCriteriaService,
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private datashareService: IstDataShareService,
    private modalService: NgbModal,
    private commonService: CommonService) {

    this.files = [];
    this.uploadInput = new EventEmitter<any>();
    //this.columnDefs = [
    //  {
    //    "headerName": "Attachment Classification",
    //    "field": "AttachmentClassification"
    //  },
    //  {
    //    "name": "File Name",
    //    "field": "FileName"
    //  },
    //  {
    //    "headerName": "Date",
    //    "field": "Date"
    //  }, {
    //    headerName: "Actions",
    //    field: "value",
    //    cellRenderer: "deleteRenderer",
    //    colId: "params",
    //    width: 80,
    //    sortable: false,
    //    cellStyle: { "overflow": 'visible' }
    //  }
    //]


  }
  ngOnInit() {
    //debugger;
    if (this.ScreenName =="Requests") {
      this.IsRequestScreen = true;
    }

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }

    this.context = { componentParent: this };
      this.frameworkComponents = {
        deleteRenderer: EditAndDeleteOperationsRenderer
      };
    this.columnDefs = [
      {
        "headerName": "Attachment Classification",
        "field": "AttachmentClassification"
      },
      {
        "headerName": "File Name",
        "field": "FileName"
      },
      {
        "headerName": "Date",
        "field": "Date"
      }
      , {
        headerName: "Actions",
        field: "value",
        cellRenderer: "deleteRenderer",
        colId: "params",
        width: 80,
        sortable: false,
        IsRequiredDelete: this.ViewPermission == 'View' ? false : true,
        IsRequiredDownLoad:true,
        cellStyle: { "overflow": 'visible' }
      }
    ];


    //setTimeout(() => {
    //  this.loadGrid = true;
    //}, 350);
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
      //debugger;
    });
    this.getAttachmentsData();

  }
  editRow() {
    var fileID = this.selectedRow['ID'];
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }
  deleteRow() {
    //debugger;
    var fileID = this.selectedRow['ID'];

    //this.summaryService.getSummaryData("api/ISTFileAttachments/DeleteFile?FileID=" + fileID).subscribe((result) => {
    //  debugger;

    //});



       let modalRef = this.modalService.open(DeleteBoxComponent,{backdrop: false});
         modalRef.result.then(result => {
          this.summaryService.DeleteRecord("api/ISTFileAttachments/DeleteFile?FileID=" + fileID).subscribe(summary => {
            //debugger;
            if (summary["Status"] == 0) {
              this.commonService.SuccessBanner("Selected Record(s) has been Deleted");
              //this.toastrService.success("Selected Record(s) has been Deleted");
              this.getAttachmentsData();
              this.rowData = result;
              setTimeout(() => {
                this.loadGrid = true;
              }, 350);
            }
            else {
              this.commonService.ValidationBanner("Error Occured while deleting Attachment");
              //this.toastrService.error("Error Occured while deleting Attachment.");
            }
          });
        })


  }
  onRowDoubleClicked(event) {
    //var fileID = event.data["ID"];
    //let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    //window.open(Url);

  }
  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  getAttachmentsData() {
    if (this.TransactionID == "" || this.TransactionID == undefined || this.TransactionID == null) {
    } else {
      this.summaryService.getSummaryData("api/ISTFileAttachments/getScreenAttachments?TransactionID=" + this.TransactionID).subscribe((result) => {
        //debugger;
        this.rowData = result;
        setTimeout(() => {
          this.loadGrid = true;
          document.body.click();
        }, 350);
      });
    }

  }

  addNewAttachment() {
    //debugger;
    if (this.TransactionID == "" || this.TransactionID == undefined || this.TransactionID == null) {
      this.commonService.ValidationBanner("Please Save Record before uploading Attachment");
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: 'Please Save Record before uploading Attachment' } } });
    } else {
      let modalRef= this.modalService.open(AttachmentClassificationComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-md modal-full-height modal-right',
        animation: true
     });
     modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: this.TransactionID, ModuleName: this.ModuleName, ScreenName: this.ScreenName }
    }
      modalRef.result.then(result => {
        this.getAttachmentsData();
      })
    }
  }
  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }
}
